export default __webpack_public_path__ + "static/proasis-logo-0a67a02b8bb26140009c6337667968d6.png";